import { render, staticRenderFns } from "./UnsavedSettingsDialog.vue?vue&type=template&id=fba3f498&"
import script from "./UnsavedSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./UnsavedSettingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports